module.exports = __webpack_public_path__ + "static/media/subscription.1f046675.svg";